import { Component } from '@angular/core';

@Component({
    selector: 'app-blank-value-dash',
    template: '--'
})
export class BlankValueDashComponent {
}
